export default __webpack_public_path__ + "static/raulAraiza-98cfb605947b875df3538daca52ab4f1.jpg";